import React, { useState } from "react";
import { motion } from "framer-motion";

import { slideInFromTop } from "shared/styles/constants";
import { ISideMenuType } from "shared/components";

import {
  MenuContent,
  StyledSideMenuProps,
} from "shared/components/SideMenu/styles";
import { SideMenuItem } from "shared/components/SideMenu/components";
import { IMenuItemType, ISideMenuItem } from "shared/components/SideMenu/types";

import { copy } from "shared/assets";
import { IconButton } from "shared/components/IconButton/IconButton";
const { menu: menuCopy } = copy;

interface AddMenuProps extends StyledSideMenuProps {
  isOpen?: boolean;
  isMenuOpen?: boolean;
  type: ISideMenuType;
  items: ISideMenuItem[] | undefined;
  onClick: () => void;
  closeMobileMenu?: () => void;
}

export const AddMenu: React.FC<AddMenuProps> = ({
  isOpen,
  isMenuOpen,
  type,
  items,
  onClick,
  closeMobileMenu,
  ...rest
}) => {
  const [expandedItemId, setExpandedItemId] = useState<string | null>(null);

  const addButton = {
    id: "add",
    title: `${menuCopy.addTo} ${type}`,
    type: IMenuItemType.action,
    actionIcon: IconButton,
  };

  const closeAllMenus = () => {
    onClick();
    closeMobileMenu && closeMobileMenu();
  };

  return (
    <MenuContent isOpen={isOpen}>
      <SideMenuItem
        {...addButton}
        isOpen={isMenuOpen}
        actionIconTransform={isMenuOpen ? "rotate(45deg)" : "none"}
        onClick={onClick}
        expandedItemId={expandedItemId}
        setExpandedItemId={setExpandedItemId}
        {...rest}
      />
      {isMenuOpen && (
        <motion.li {...slideInFromTop}>
          <ul>
            {items?.map(({ ...menuItem }) => (
              <SideMenuItem
                key={menuItem.id}
                {...menuItem}
                subItemIndex={1}
                onClick={closeAllMenus}
                expandedItemId={expandedItemId}
                setExpandedItemId={setExpandedItemId}
                {...rest}
              />
            ))}
          </ul>
        </motion.li>
      )}
    </MenuContent>
  );
};
